export class ViewerControlsController {
  constructor(viewer) {
    this.viewer = viewer;
    this._active = false;
    this._unmounted = false;
  }
  controls() {
    return this._controls;
  }
  mount() {
    this._unmounted = false;
    const controlsNode = this.viewer.controlsNode();
    const camera = this.viewer.camera();
    if (!(controlsNode && camera)) {
      return;
    }
    controlsNode.applyControls(camera, this.viewer).then((controls) => {
      this._controls = controls;
      this._updateControlsFunc = controls ? controls.update : void 0;
      if (this._unmounted) {
        this._disposeControls();
      }
    });
  }
  unmount() {
    this._unmounted = true;
    this._disposeControls();
  }
  _disposeControls() {
    if (this._controls) {
      this._controls.dispose();
    }
    this._updateControlsFunc = void 0;
  }
  update(delta) {
    if (this._updateControlsFunc) {
      this._updateControlsFunc(delta);
    }
  }
}
